module.exports = {
      id: "launcher-usage",
      viewBox: "0 0 28 28",
      url: "/" + "sprite-f96a299a5e63739e5b36582e48c149a3.svg#launcher",
      toString: function () {
        return this.url;
      }
    }